import React from 'react';
import { 
  Box, 
  Container, 
  Grid, 
  Typography, 
  List, 
  ListItem, 
  ListItemIcon, 
  ListItemText, 
  Paper 
} from '@mui/material';
import { 
  CheckCircleOutline, 
  Restaurant, 
  TabletMac, 
  DinnerDining, 
  ReceiptLong, 
  People 
} from '@mui/icons-material';
import PublicLayout from "../../layouts/PublicLayout";

export default function FineDine() {
  return (
    <PublicLayout>
      <Box sx={{ bgcolor: '#fff', py: { xs: 8, md: 10 } }}>
        <Container maxWidth="lg">
          <Grid container spacing={8} alignItems="flex-start">
            
            {/* LEFT CONTENT */}
            <Grid item xs={12} md={7}>
              <Typography variant="overline" sx={{ color: '#f6521a', fontWeight: 800, letterSpacing: 1.5 }}>
                TPOS FOR FINE DINE & FULL-SERVICE
              </Typography>
              
              <Typography variant="h2" sx={{ fontWeight: 600, mt: 1, mb: 2, fontSize: { xs: '1.5rem', md: '2.5rem' }, lineHeight: 1.1 }}>
                Elevate the Guest Experience with <span style={{ color: "#f6521a" }}>Flawless Table Management.</span>
              </Typography>

              <Typography variant="h6" sx={{ color: 'text.secondary', fontWeight: 500, mb: 4, lineHeight: 1.5 }}>
                Empower your captains with tableside ordering, manage course-wise kitchen routing, and handle complex split bills with elegance.
              </Typography>

              <Typography variant="body1" sx={{ color: 'text.primary', mb: 5, fontSize: '1.1rem', lineHeight: 1.8 }}>
                In fine dining, the atmosphere and quality of service are just as important as the food itself. Your captains shouldn't be running back and forth to a terminal to punch in orders. 
                <strong> TPOS brings the power of the restaurant to your staff's fingertips</strong> with digital captain apps. From capturing detailed guest preferences to routing appetizers and mains sequentially to the kitchen, TPOS ensures a seamless, high-end dining experience.
              </Typography>

              <Typography variant="h5" sx={{ fontWeight: 700, mb: 3 }}>
                Specialized TPOS Features:
              </Typography>

              <Grid container spacing={3}>
                {[
                  {
                    title: "Visual Table & Section Mapping",
                    desc: "A real-time, color-coded floor plan on your POS. Instantly see which tables are vacant, occupied, or waiting for their bill.",
                    icon: <Restaurant sx={{ color: '#f6521a' }} />
                  },
                  { 
                    title: "Captain Ordering App (Tableside)", 
                    desc: "Equip your staff with tablets or smartphones to take orders directly at the table, instantly firing KOTs to the kitchen.",
                    icon: <TabletMac sx={{ color: '#f6521a' }} />
                  },
                  { 
                    title: "Course-Wise KOT Routing", 
                    desc: "Send orders to the kitchen grouped by course. Fire starters immediately, and hit 'Fire Mains' later for perfect plating timing.",
                    icon: <DinnerDining sx={{ color: '#f6521a' }} />
                  },
                  { 
                    title: "Advanced Split Bill & Merge Table", 
                    desc: "Flawlessly execute complex guest requests. Split the check equally, item-by-item, or by seat number without breaking a sweat.",
                    icon: <ReceiptLong sx={{ color: '#f6521a' }} />
                  },
                  { 
                    title: "Guest CRM & Preference Tracking", 
                    desc: "Pull up a returning guest's profile to see their favorite wine, preferred table, or allergy before they even sit down.",
                    icon: <People sx={{ color: '#f6521a' }} />
                  }
                ].map((item, index) => (
                  <Grid item xs={12} sm={6} key={index}>
                    <Box sx={{ display: 'flex', alignItems: 'flex-start', gap: 2, mb: 2 }}>
                      <Box sx={{ mt: 0.5 }}>{item.icon}</Box>
                      <Box>
                        <Typography variant="subtitle1" sx={{ fontWeight: 700 }}>{item.title}</Typography>
                        <Typography variant="body2" sx={{ color: 'text.secondary' }}>{item.desc}</Typography>
                      </Box>
                    </Box>
                  </Grid>
                ))}
              </Grid>

            </Grid>

            {/* RIGHT IMAGE */}
            <Grid item xs={12} md={5} sx={{ position: 'sticky', top: 100 }}>
              <Paper 
                elevation={0} 
                sx={{ 
                  borderRadius: 4, 
                  overflow: 'hidden', 
                  background: 'linear-gradient(145deg, #ffffff 0%, #f9f9f9 100%)',
                  p: 2,
                  display: 'flex',
                  flexDirection: 'column',
                  alignItems: 'center',
                  justifyContent: 'center',
                  height: '100%'
                }}
              >
                <Box
                  sx={{
                    width: '100%',
                    height: { xs: 300, md: 550 },
                    borderRadius: 3,
                    overflow: 'hidden',
                    display: 'flex',
                    alignItems: 'right',
                    float:'right'                    
                  }}
                >
                  <img 
                    src="/img/home-banner.jpg" 
                    alt="Fine Dine POS Management" 
                    style={{ width: '100%', height: '100%', objectFit: 'cover', display: 'block' }}
                  />
                </Box>
                
                <Box sx={{ p: 3, width: '100%' }}>
                  <Typography variant="h6" sx={{ fontWeight: 700, mb: 1 }}>Business Impact</Typography>
                  <List dense>
                    <ListItem disableGutters>
                      <ListItemIcon sx={{ minWidth: 35 }}><CheckCircleOutline sx={{ color: '#00ab55', fontSize: 20 }} /></ListItemIcon>
                      <ListItemText primary="Improve table turnover rates by 20% without ever making your guests feel rushed." />
                    </ListItem>
                    <ListItem disableGutters>
                      <ListItemIcon sx={{ minWidth: 35 }}><CheckCircleOutline sx={{ color: '#00ab55', fontSize: 20 }} /></ListItemIcon>
                      <ListItemText primary="Increase average cover value by prompting captains with smart upselling suggestions." />
                    </ListItem>
                  </List>
                </Box>
              </Paper>
            </Grid>

          </Grid>
        </Container>
      </Box>
    </PublicLayout>
  );
}